module.exports = __webpack_public_path__ + "static/media/jp.28157b52.svg";